// Cross-tab hotel preview cache.
// sessionStorage doesn't survive `window.open(..., 'noopener')` — that's why
// the search-results tab and the details tab must share state via localStorage.
// Entries expire after 60 minutes so we don't accumulate stale rates.

const KEY_PREFIX = 'elite_hotel_preview_';
const TTL_MS = 60 * 60 * 1000; // 60 minutes

export const saveHotelPreview = (hotelId, hotel) => {
  if (!hotelId || !hotel) return;
  try {
    localStorage.setItem(
      `${KEY_PREFIX}${hotelId}`,
      JSON.stringify({ savedAt: Date.now(), hotel }),
    );
  } catch { /* quota / privacy mode — ignore */ }
};

export const loadHotelPreview = (hotelId) => {
  if (!hotelId) return null;
  try {
    const raw = localStorage.getItem(`${KEY_PREFIX}${hotelId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || Date.now() - parsed.savedAt > TTL_MS) {
      localStorage.removeItem(`${KEY_PREFIX}${hotelId}`);
      return null;
    }
    return parsed.hotel || null;
  } catch { return null; }
};
